import React from 'react';

const Vue_Intro = () => {
  return (
    <div>
      <h1>Vue_Intro Component</h1>
      <p>This is the Vue_Intro tutorial page.</p>
    </div>
  );
}

export default Vue_Intro;
